import React, { useState, useMemo } from 'react';
import { Box, Typography, Divider, Button, IconButton, Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/layout';
import { useForm, FormProvider } from 'react-hook-form';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import { conditionsOptions, dataTypeOptions, policies, createConditionFields, ConditionComponent } from './ConnectionComponent';


export default function LinkComponent({ task, handleLink, optionsAction, linkMode, handleLinkMode, handleCancel }) {
  const [t] = useTranslation();

  const methods = useForm({
    defaultValues: {
      action: 'succed'
    }
  });
  const { handleSubmit, watch, setValue, unregister } = methods;
  const watchAction = watch('action');
  const watchConditions = watch('conditions');
  const [conditionFields, setConditionFields] = useState([]);

  function handleAddCondition(e) {
    e.preventDefault();
    setConditionFields([
      ...conditionFields,
      {
        field: 'condition',
        condition: conditionsOptions[0].value,
        dataType: dataTypeOptions[0].value,
        value: 'empty'
      }
    ]);
  }

  function handleOnSubmit(data) {
    const { action, ...fields } = data;
    const connections = Object.values(linkMode.nodes).map((c) => {
      let objectConnection = {
        conx: action,
        id_nodo: c.id_nodo
      }
      if (action === "condition") objectConnection['conditions'] = Object.values(fields);
      return objectConnection;
    })

    const mergedArray = task.conn.concat(connections);
    task.conn = Object.values(mergedArray.reduce((acc, current) => {
      acc[current.id_nodo] = current;
      return acc;
    }, {}));

    handleLink(task);
  }

  function handleRemoveCondition(e, indexToRemove) {
    e.preventDefault();
    setConditionFields(
      conditionFields.filter((item, index) => index !== indexToRemove)
    );
    unregister(`${indexToRemove}`);
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      overflowY: 'auto' }}
    >
      <FormProvider { ...methods }>
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <Box sx={{ display: 'flex', p: 2, flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6">{t('workflowEdit.components.task.linkLabel')}</Typography>
            <Divider/>
            <Input
              {...policies.action}
              options={optionsAction}
              sx={{ width: '100%' }}
            />
            <Divider/>

            { watchAction === 'condition' &&
              <>
                { conditionFields.map((field, index) => (
                  <ConditionComponent key={index} index={index} fieldsValues={field} setValue={setValue} handleRemoveCondition={handleRemoveCondition} t={t}/>
                ))}
                <Button variant="text" sx={{ width: '100%' }} onClick={handleAddCondition}>
                  {t('workflowEdit.components.task.form.condition')}
                </Button>
                <Divider/>
              </>
            }

            <Button variant="outlined" sx={{ width: '100%' }} type='submit'>
              {t('workflowEdit.components.task.form.save')}
            </Button>
          </Box>
        </form>
      </FormProvider>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pb: 4, justifyContent: 'flex-end' }}>
        <Button variant="text" sx={{ width: '100%' }} onClick={handleCancel}>
          {t('workflowEdit.components.task.form.cancel')}
        </Button>
      </Box>
    </Box>
  );
}
